module.exports = __webpack_public_path__ + "img/icon-bag-ar.52299b85.svg";